module.exports = __webpack_public_path__ + "static/media/space-one.249bca81.svg";